import styles from "@css/modules/pointsGuide.module.scss"
import { useState } from "react"
import cn from "classnames"
import { Step5Icon1 } from "./step-icons/Step5Icon1"
import { Step5Icon2 } from "./step-icons/Step5Icon2"
import { Step5Icon3 } from "./step-icons/Step5Icon3"
import { Step5Icon4 } from "./step-icons/Step5Icon4"
import { Step5Icon5 } from "./step-icons/Step5Icon5"

const list = {
    studio: {
        icon: Step5Icon1
    },
    "hotel room": {
        icon: Step5Icon1
    },
    "deluxe inn room": {
        icon: Step5Icon1
    },
    "tower studio": {
        icon: Step5Icon1
    },
    "deluxe studio": {
        icon: Step5Icon1
    },
    "one-bedroom villa": {
        icon: Step5Icon2
    },
    "1 bedroom": {
        icon: Step5Icon2
    },
    "2 bedroom": {
        icon: Step5Icon3
    },
    "two-bedroom villa": {
        icon: Step5Icon3
    },
    "three-bedroom grand villa": {
        icon: Step5Icon4
    },
    "3 bedroom": {
        icon: Step5Icon4
    },
    bungalow: {
        icon: Step5Icon5
    },
    "grand villa": {
        icon: Step5Icon5
    },
    "2 bedroom bungalow": {
        icon: Step5Icon5
    },
    cabin: {
        icon: Step5Icon5
    },
    treehouse: {
        icon: Step5Icon5
    },
    "beach cottage": {
        icon: Step5Icon5
    }
}

export function Step5({ onChange, goNext, goBack, lastValue, data }) {
    const [roomTypes] = useState(() => {
        const { currentChart } = data["4"]
        return (
            currentChart?.headers
                ?.map((i) => {
                    const title = i.title.toLowerCase().trim()
                    return {
                        icon: () => null,
                        ...list[title],
                        text: i.title,
                        column: i.column,
                        members: i.sub_title
                    }
                })
                .filter((i) => i?.text) || []
        )
    })
    const [value, setValue] = useState(() => {
        if (lastValue) {
            return roomTypes.find((i) => i.text === lastValue.text)
        }
        return null
    })

    const localSetValue = (val) => {
        setValue(val)
        onChange(val)
    }
    const onGoNext = () => {
        if (value) {
            goNext()
        }
    }
    return (
        <div className={styles.stepContainer}>
            <div className={styles.stepContent} id="scroll-target">
                <h2>What size room do you wish to stay in?</h2>
                <div className={styles.stepIcons}>
                    {roomTypes.map((i, index) => {
                        const Icon = i.icon
                        return (
                            <button
                                key={index}
                                className={cn({
                                    [styles.stepIconBtn]: true,
                                    [styles.step5IconBtn]: true,
                                    [styles.stepIconBtnActive]: value === i
                                })}
                                onClick={() => localSetValue(i)}>
                                <Icon />
                                <div className={styles.btnContent}>
                                    <div className={styles.stepIconText}>{i.text}</div>
                                    <div className={styles.stepIconSub}>{i.members}</div>
                                </div>
                            </button>
                        )
                    })}
                </div>
                <div className={styles.overBackNext}>
                    <button className={styles.goBack} onClick={goBack}>
                        Back
                    </button>
                    <button disabled={!value} className={styles.goNext} onClick={onGoNext}>
                        See My Results
                    </button>
                </div>
            </div>
        </div>
    )
}
